import "./App.css";
import { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { HashRouter, Routes, Route } from "react-router-dom";

import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Home from "./Pages/Home";
import BCA from "./Pages/BCA";
import MCA from "./Pages/MCA";
import Error from "./Components/Error";
import TeachingMembers from "./Pages/TeachingMembers";
import NonTeachingMembers from "./Pages/NonTeachingMembers";
import Auditorium from "./Pages/Campus/Auditorium";
import BotanicalGardern from "./Pages/Campus/BotanicalGarden";
import Canteen from "./Pages/Campus/Canteen";
import CentralLibrary from "./Pages/Campus/CentralLibrary";
import DigitalClass from "./Pages/Campus/DigitalClass";
import Ground from "./Pages/Campus/Ground";
import Gym from "./Pages/Campus/Gym";
import Library from "./Pages/Campus/Library";
import LibraryBooks from "./Pages/Campus/LibraryBooks";
import Park from "./Pages/Campus/Park";
import SolarPower from "./Pages/Campus/SolarPower";
import DirectorMessage from "./Pages/DirectorMessage";
import Gallery from "./Pages/Gallery";
import AboutUs from "./Pages/AboutUs";
import ContactUs from "./Pages/ContactUs";
import AdmissionProcess from "./Pages/AdmissionProcess";
import TopBtn from "./Components/TopBtn";
import Alumni from "./Pages/Alumni";
import Research from "./Pages/Research";
import AlumniLIst from "./Pages/AlumniLIst";
import FeeStructure from "./Pages/FeeStructure";
import NoticeAll from "./Pages/NoticeAll";
import Committee from "./Pages/Committee";
import Complaint from "./Pages/Complaint";
import FeeSubmission from "./Pages/FeeSubmission";
import Feedback from "./Pages/Feedback";
import Grievance from "./Pages/Grievance";
import EOA from "./Pages/EOA";
import AICTEStatutoryCommittees from "./Pages/AICTEStatutoryCommittees";
import LabSoftware from "./Pages/LabSoftware";
import SeminarHall from "./Pages/Campus/SeminarHall";
import ClubAndCell from "./Pages/Campus/ClubAndCell";
import MandatoryDisclosures from "./Pages/MandatoryDisclosures";
import AtmAndBanks from "./Pages/Campus/AtmAndBanks";
import ComputerCenter from "./Pages/Campus/ComputerCenter";
import Insurance from "./Pages/Campus/Insurance";
import QuickLinks from "./Pages/QuickLinks";

// Co-Curricular Imports
import { 
	Sports, 
	NCC, 
	NSS, 
	NCDRC, 
	UBA, 
	WomenEmpowerment,
	InductionProgram
} from "./Pages/CoCurricular/CoCurricular";

function App() {
	useEffect(() => {
		Aos.init({ duration: 1500 });
	}, []);

	return (
		<>
			<HashRouter>
				<Navbar />
				<Routes>
					<Route exact path="/" element={<Home />} />
					<Route exact path="/teachingMembers" element={<TeachingMembers />} />
					<Route
						exact
						path="/nonTeachingMembers"
						element={<NonTeachingMembers />}
					/>
					<Route exact path="/directorMessage" element={<DirectorMessage />} />
					<Route exact path="/allNotice" element={<NoticeAll />} />
					<Route exact path="*" element={<Error />} />
					<Route exact path="/BCA" element={<BCA />} />
					<Route exact path="/MCA" element={<MCA />} />
					<Route exact path="/research" element={<Research />} />

					<Route exact path="/auditorium" element={<Auditorium />} />
					<Route exact path="/botanicalGarden" element={<BotanicalGardern />} />
					<Route exact path="/canteen" element={<Canteen />} />
					<Route exact path="/centralLibrary" element={<CentralLibrary />} />
					<Route exact path="/digitalClass" element={<DigitalClass />} />
					<Route exact path="/ground" element={<Ground />} />
					<Route exact path="/gym" element={<Gym />} />
					<Route exact path="/library" element={<Library />} />
					<Route exact path="/libraryBooks" element={<LibraryBooks />} />
					<Route exact path="/seminarHall" element={<SeminarHall />} />
					<Route exact path="/labSoftware" element={<LabSoftware />} />
					<Route exact path="/park" element={<Park />} />
					<Route exact path="/solarPower" element={<SolarPower />} />
					<Route exact path="/clubAndCell" element={<ClubAndCell />} />
					<Route exact path="/atmAndBanks" element={<AtmAndBanks />} />
					<Route exact path="/computerCenter" element={<ComputerCenter />} />
					<Route exact path="/insurance" element={<Insurance />} />
					<Route exact path="/quickLinks" element={<QuickLinks />} />

					{/* Co-Curricular Routes */}
					<Route exact path="/sports" element={<Sports />} />
					<Route exact path="/ncc" element={<NCC />} />
					<Route exact path="/nss" element={<NSS />} />
					<Route exact path="/ncdrc" element={<NCDRC />} />
					<Route exact path="/uba" element={<UBA />} />
					<Route exact path="/womenEmpowerment" element={<WomenEmpowerment />} />
					<Route exact path="/inductionProgram" element={<InductionProgram />} />

					<Route exact path="/alumniForm" element={<Alumni />} />
					<Route exact path="/alumniList" element={<AlumniLIst />} />
					<Route
						exact
						path="/admissionProcess"
						element={<AdmissionProcess />}
					/>
					<Route exact path="/feeStructure" element={<FeeStructure />} />
					<Route exact path="/gallery" element={<Gallery />} />
					<Route exact path="/about" element={<AboutUs />} />
					<Route exact path="/contact" element={<ContactUs />} />
					<Route exact path="/committee" element={<Committee />} />
					<Route exact path="/complaint" element={<Complaint />} />
					<Route exact path="/feeSubmission" element={<FeeSubmission />} />
					<Route exact path="/feedback" element={<Feedback />} />
					<Route exact path="/grievance" element={<Grievance />} />
					<Route exact path="/eoa" element={<EOA />} />
					<Route exact path="/aicteCommittees" element={<AICTEStatutoryCommittees />} />
					<Route exact path="/mandatoryDisclosures" element={<MandatoryDisclosures />} />
				</Routes>

				<Footer />
			</HashRouter>

			<TopBtn />
		</>
	);
}

export default App;
